/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { attemptsRetry } from "../../funcs/attemptsRetry.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.RetryRequest$inboundSchema,
};

export const tool$attemptsRetry: ToolDefinition<typeof args> = {
  name: "attempts-retry",
  description: `Retry Event Delivery

Triggers a retry for delivering an event to a destination. The event must exist and the destination must be enabled and match the event's topic.

When authenticated with a Tenant JWT, only events belonging to that tenant can be retried.
When authenticated with Admin API Key, events from any tenant can be retried.
`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await attemptsRetry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
